// extracted by mini-css-extract-plugin
module.exports = {"header":"Panel_header__1k4HW","content":"Panel_content__3JrnZ","panel":"Panel_panel__8k96J"};